import { graphql } from "@/lib/gql/__generated__/gql";

export const UpdateRoomListMutation = graphql(/* GraphQL */ `
	mutation RoomListUpdate($input: RoomListInput!) {
		roomListUpdate(input: $input) {
			roomList {
				dummy {
					capacityAdultMaximum
					capacityKidsMaximum
					capacityPeopleMaximum
					catchCopy
					description
					hotelID
					id
					inSale
					isKidsUnavailable
					keyVisuals {
						bucket
						fileName
						key
						mimeType
						region
					}
					kidsPolicy {
						kidsDiscountType
						kidsMaxAge
						ratio
						static {
							amount
							currencyType
						}
					}
					mainKeyVisual {
						bucket
						fileName
						key
						mimeType
						region
					}
					maxRoomNum
					name
					roomID
				}
				hotelID
				id
				rooms {
					address {
						city
						nationality
						other
						postalCode
						pref
						state
						town
					}
					amenities
					beds {
						bedNum
						bedType
					}
					capacityAdultMaximum
					capacityKidsMaximum
					capacityPeopleMaximum
					catchCopy
					description
					geoLocation {
						lat
						lon
					}
					hotelID
					id
					inSale
					isDormitoryType
					isExtendSiteControllerPeopleNum
					isKidsUnavailable
					maxRoomNum
					name
					overSiteControllerPeopleNum {
						availableWeekDays
						prices {
							price {
								amount
								currencyType
							}
							upperNum
						}
					}
					requiredPrepMillisecond
					roomID
					roomSize
					saleTypeForPlan
				}
			}
			userErrors
		}
	}
`);
